import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Techstackcloudinfra() {
  return (
    <section
      className="tech_stack_cloud_infra p-100"
      style={{ background: "#F8F8FB" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Tech Stack We Use for Cloud infratructure Management Solutions
            </h2>
            <p>
              To efficiently manage cloud infrastructure, we use a wide range of
              tools and technologies. Here's an overview of our core tools:
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <div className="tech_stack_main">
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/google_cloud.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Google Cloud Platform</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/aws.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>AWS (Amazon Web Services)</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/azure.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Microsoft Azure</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/docker.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Docker</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/kuber.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Kubernetes</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/jenkins.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Jenkins</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/git_lab.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>GitLab</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/git_hub.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>GitHub</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/bitbucket.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Bitbucket</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/prome.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Prometheus</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/grafana.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Grafana</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/zabbix.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Zabbix</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/ansible.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Ansible</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/puppet.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Puppet</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/mariadb.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>MariaDB</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/oracle.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Oracle</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/mangodb.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>MongoDB</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/postgre_sql.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>PostgreSQL</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/my_sql.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>MySQL</h5>
                </div>
              </div>
              <div className="tech_stack_item">
                <div className="tech_stack_img">
                  <StaticImage
                    src="../../images/services-usa/cloud-infra/terraform.webp"
                    alt="tekrevol"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={126}
                    height={126}
                  />
                </div>
                <div className="tech_stack_content">
                  <h5>Terraform</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Techstackcloudinfra;
